var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex relative"},[_c('SideBar'),_c('div',{staticClass:"grow h-screen ml-64 p-4"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }